<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="text-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="text-danger icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.exportReceipts')" position="top">
                <feather-icon icon="FileTextIcon" class="text-warning icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click="exportReceipts"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupDetailsReceipts"
                  v-if="popupDetailsReceipts" id="popup_details_receipts">
            <ReceiptsDetails :receiptsId="params.data.id"></ReceiptsDetails>
        </vs-popup>
    </div>
</template>

<script>
import ReceiptsDetails from "../ReceiptsDetails";
import moment from "moment";

export default {
    name: "CellRendererActions",
    components: {
        ReceiptsDetails
    },
    data() {
        return {
            popupDetailsReceipts: false,
            classOptions: [],
            studentOptions: [],
        }
    },

    methods: {
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá phiếu thu này không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$vs.loading();
            this.$crm.delete(`/tuition-bill/delete/${this.params.data.id}?organizationId=${userInfo.organization.id}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Xoá phiếu thu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_RECEIPTS', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        editRecord() {
            this.popupDetailsReceipts = true;
        },

        getClassByBranch() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.params.data.organizationBranchId,
                    pageNumber: 0,
                    pageSize: 1000,
                }
                this.classOptions = [];
                this.$vs.loading();
                this.$crm.post('/school-classroom/search', payload).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.classOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.className,
                            }
                        })
                    }
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getStudentByClass() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.params.data.organizationBranchId,
                    classId: this.params.data.classId,
                    pageNumber: 1,
                    pageSize: 1000,
                }
                this.studentOptions = [];
                this.$vs.loading();
                this.$crm.post('/school-student/search', payload).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.studentOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName,
                            }
                        })
                    }
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async exportReceipts() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]'),
                branchName = branchList.find(el => el.id === this.params.data.organizationBranchId).organizationBranchName,
                className = null, studentName = null;
            if (this.params.data.classId) {
                console.log(1)
                await this.getClassByBranch();
                className = this.classOptions.find(el => el.value === this.params.data.classId).label;

                if (this.params.data.studentId) {
                    console.log(this.params.data.studentId)
                    await this.getStudentByClass();
                    studentName = this.studentOptions.find(el => el.value === this.params.data.studentId).label;
                }
            }
            let paymentDate = moment(this.params.data.paymentDate).format('[Ngày] DD [tháng] MM [năm] YYYY'),
                details = this.params.data.schoolTuitionBillDetailList,
                table = details.map(el => {
                    return `<tr><td style="text-align: center;">${details.indexOf(el) + 1}</td><td>${el.product}</td><td style="text-align: center;">${el.unit}</td><td style="text-align: center;">${el.quantity}</td><td style="text-align: right;">${el.unitPrice.toLocaleString()}</td><td style="text-align: right;">${el.amount.toLocaleString()}</td></tr>`
                }),
                data = table.reduce((partialSum, a) => partialSum + a, ''),
                html = `<!DOCTYPE html>
            <html lang="vi">
            <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <style>
            body { font-family: 'Times New Roman', serif; }
            .header {
            display: flex;
            justify-items: center;
            align-items: center;
            justify-content: center;
            text-align: center;

              .info {
              margin-left: 1em;
                p {margin-block: 0.1em}
                h2 {margin-block-end: 0.1em}
              }
            }
            .logo { width: 100px; }
            .table { width: 100%; border-collapse: collapse; }
            .table th, .table td { border: 1px solid #ddd; padding: 8px; }
            .table th { background-color: #f2f2f2; }
            .footer { margin-top: 2rem; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); text-align: center; }
            .title {text-align: center; margin-block-end: 0.1em}
            .paymentDate {text-align: center; margin-block-start: 0.1em; font-style: italic;}
            .money {text-align: right;}
            .text-footer {font-weight: bold;}
            </style>
            </head>
            <body>
            <div class="header">
              <img src="https://hinode.vn/wp-content/uploads/2019/11/Logo.png" alt="Logo" class="logo">
              <div class="info">
                <h2>TRUNG TÂM NGOẠI NGỮ BÌNH MINH - HINODE</h2>
                <p>15/24 Kim Đồng - Giáp Bát - Hoàng Mai - Hà Nội</p>
                <p>SDT: (024)3864 4426 | Fax: (024)3642 5597</p>
                <p>Website: www.hinode.vn</p></div>
            </div>

            <h3 class="title">PHIẾU THU</h3>
            <p class="paymentDate">${paymentDate}</p>

            <table class="table">
             <tr>
                <th>Trường</th>
                <td>${branchName}</td>
              </tr>
               ${className ? `<tr><th>Lớp</th><td>${className}</td></tr>` : ''}
               ${studentName ? `<tr><th>Tên học sinh</th><td>${studentName}</td></tr>` : ''}
            </table>

            <table class="table">
              <thead>
                <tr>
                  <th>${this.$t('invoice.index')}</th>
                  <th>${this.$t('invoice.product')}</th>
                  <th>${this.$t('invoice.unit')}</th>
                  <th>${this.$t('invoice.quantity')}</th>
                  <th>${this.$t('invoice.unitPrice')}</th>
                  <th>${this.$t('invoice.amount')}</th>
                </tr>
              </thead>
              <br>
              <tbody>
                ${data}
                <tr>
                   <td colspan="5" class="text-footer">Giảm trừ</td>
                    <td class="money">${this.params.data.deduction.toLocaleString()}</td>
                </tr>
                <tr>
                   <td colspan="5" class="text-footer">Tổng số tiền thanh toán</td>
                    <td class="money">${this.params.data.amount.toLocaleString()}</td>
                </tr>
                <tr>
                   <td colspan="6">
                   <span class="text-footer">Bằng chữ: </span>
                    <span>${this.params.data.displayMoney}</span>
                   </td>
                </tr>
                <tr>
                   <td colspan="6">
                   <span class="text-footer">Ghi chú: </span>
                    <span>${this.params.data.note ? this.params.data.note : ''}</span>
                   </td>
                </tr>
              </tbody>
            </table>

            <div class="footer">
              <div>
                <div>
                  <span class="text-footer">Học sinh</span>
                </div>
                <span>(Ký và ghi rõ họ tên)</span>
              </div>
              <div>
                <div>
                  <span class="text-footer">Người thu tiền</span>
                </div>
                <span>(Ký và ghi rõ họ tên)</span>
              </div>
            </div>
            </body>
            </html>`
            let printWin = window.open(' ', '', 'width=1197,height=793');
            printWin.document.open();
            printWin.document.write(html);
            printWin.document.close();
            setTimeout(() => {
                printWin.focus();
                printWin.print();
            }, 100);
            // printWin.onafterprint = (event) => {
            // }

        }
    },

    mounted() {
        this.$eventBus.$on('close-popup-details-receipts', () => {
            this.popupDetailsReceipts = false;
        })
    }
}
</script>

<style lang="scss">
#popup_details_receipts {

    .vs-popup--header {
        display: none;
    }

    .vs-popup {
        width: 1400px !important;
    }
}
</style>
